import React, { useEffect, useState } from "react";
import client from "@/lib/api";
import { money, fmtDate } from "@/lib/format";
import { Loader2 } from "lucide-react";

interface Mov { id: string; date: string; description: string; type: string; amount: number; category: string; tags?: { canal?: string } }

const lastDay = (m: string) => new Date(parseInt(m.slice(0, 4), 10), parseInt(m.slice(5, 7), 10), 0).getDate();

export const PlatformChargesDetail: React.FC<{ month: string; channel: string; onClose: () => void }> = ({ month, channel, onClose }) => {
  const [rows, setRows] = useState<Mov[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params: Record<string, string> = { ledger: "platform", channel, date_from: `${month}-01`, date_to: `${month}-${lastDay(month)}` };
    client.get("/cash/movements", { params }).then((r) => setRows(r.data)).finally(() => setLoading(false));
  }, [month, channel]);

  return (
    <div className="border border-slate-200 bg-white" data-testid="platform-charges-detail">
      <div className="flex flex-wrap items-center gap-3 border-b border-slate-200 p-4">
        <h3 className="mr-auto text-sm font-semibold text-slate-800">Pedidos y cargos · {channel} · {month}</h3>
        <button onClick={onClose} data-testid="detail-close" className="text-xs text-slate-400 hover:text-slate-700">Cerrar</button>
      </div>
      {loading ? (
        <div className="flex h-40 items-center justify-center"><Loader2 className="h-5 w-5 animate-spin text-[#DD0000]" /></div>
      ) : (
        <div className="max-h-[560px] overflow-y-auto">
          <table className="w-full text-sm">
            <tbody>
              {rows.map((m) => (
                <tr key={m.id} className="border-b border-slate-50" data-testid={`platform-mov-${m.id}`}>
                  <td className="px-5 py-2.5 text-slate-500">{fmtDate(m.date)}</td>
                  <td className="px-3 py-2.5 text-slate-700">{m.description}</td>
                  <td className="px-3 py-2.5 text-xs text-slate-400">{m.tags?.canal}</td>
                  <td className={`px-5 py-2.5 text-right font-medium tabular ${m.type === "inflow" ? "text-emerald-600" : "text-red-600"}`}>
                    {m.type === "inflow" ? "+" : "−"}{money(m.amount)}
                  </td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td className="p-8 text-center text-sm text-slate-400">Sin movimientos de plataformas en este mes</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
